var transitionDuration = 350;

function doc_keyUp(e) {
    if (e.ctrlKey && e.keyCode == 79) {
        $('#debugModal').modal('show');
    }
}

function siteFade() {
    setTimeout(function () {
        $('body').addClass('render');
    }, 60);

    $('.js-site--fade').on('click', function (e) {
        if ($(this).attr("href").indexOf("mailto:") == -1 && $(this).attr("target") != "_blank") {
            e.preventDefault();
            if ($(this).attr('href') != '#') {
                var url = $(this).attr('href');
                $('body').removeClass('render');
                setTimeout(function () {
                    window.location = url;
                }, transitionDuration);
            }
        }
    });
}

function jsLink() {
    setTimeout(function () {
        $('body').addClass('render');
    }, 60);

    $('.js-link').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('w')) {
            window.open($(this).data('href'), '_blank');
        } else {
            var url = $(this).data('href');
            $('body').removeClass('render');
            setTimeout(function () {
                window.location = url;
            }, transitionDuration);
        }
    });
}

function goBack() {
    $('body').removeClass('render');
    setTimeout(function () {
        window.history.back();
    }, 350);
}

function initializeMap(idMap, grey, infoBox) {

    if (grey === true) {
        var snazzy = [{
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [{"color": "#444444"}]
        }, {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#f2f2f2"}]}, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{"visibility": "off"}]
        }, {"featureType": "poi", "elementType": "labels.text", "stylers": [{"visibility": "off"}]}, {
            "featureType": "road",
            "elementType": "all",
            "stylers": [{"saturation": -100}, {"lightness": 45}]
        }, {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [{"visibility": "simplified"}]
        }, {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [{"visibility": "off"}]
        }, {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"}]}, {
            "featureType": "water",
            "elementType": "all",
            "stylers": [{"color": "#dbdbdb"}, {"visibility": "on"}]
        }];
    }

    // var lat = $('#js-map-canvas').data('lat');
    // var lng = $('#js-map-canvas').data('lng');
    //
    // var myLatlng = new google.maps.LatLng(lat, lng);

    var bounds = new google.maps.LatLngBounds();

    var myLatLng = {lat: 49.663186, lng: 6.017145};

    var mapOptions = {
        zoom: 14,
        zoomControl: true,
        streetViewControl: false,
        mapTypeControl: false,
        center: myLatLng
    };

    map = new google.maps.Map(document.getElementById(idMap), mapOptions);

    if (grey === true) {
        var mapType = new google.maps.StyledMapType(snazzy, {name: "Grayscale"});
        map.mapTypes.set('snazzy', mapType);
        map.setMapTypeId('snazzy');
    }

    var imageBlue = {
        url: '/src/images/marker-blue.svg',
        scaledSize: new google.maps.Size(44, 60)
    };

    var imageRed = {
        url: '/src/images/marker-red.svg',
        scaledSize: new google.maps.Size(44, 60)
    };

    $('.repeat-map .info-data-map').each(function () {
        var latLng = {lat: parseFloat($(this).data('lat')), lng: parseFloat($(this).data('lng'))};

        bounds.extend(latLng);

        var color = $(this).data('color');
        var iconMarker = color == 'blue' ? imageBlue : imageRed;

        var marker = new google.maps.Marker({
            position: latLng,
            map: map,
            icon: iconMarker
        });

        if (infoBox === true) {
            var contentString = $('#js-map-canvas').data('text');

            // var infoWindow = new google.maps.InfoWindow({
            //     content: contentString,
            //     maxWidth: 200,
            //     maxHeight: 200
            // });

            infoWindow = new google.maps.InfoWindow({
                pixelOffset: new google.maps.Size(0, -20)
            });

            google.maps.event.addListener(map, 'click', function () {
                infoWindow.close(map);
            });

            var infoHtml = "<div class='map-box'>" + "<h3 class='heading-4 fw-light mb-3'>" + $(this).data('title') + "</h3>" + $(this).data('text') + "</div>";

            google.maps.event.addListener(marker, 'click', (function () {
                return function () {
                    infoWindow.setContent(infoHtml);
                    infoWindow.setPosition(marker.getPosition());
                    infoWindow.open(map);
                }
            })(marker));
        }
    });

    map.fitBounds(bounds);

    // if (infoBox === true) {
    //     var contentString = $('#js-map-canvas').data('map');
    //
    //     var infowindow = new google.maps.InfoWindow({
    //         content: contentString,
    //         maxWidth: 200,
    //         maxHeight: 200
    //     });
    // }
    //
    // var marker = new google.maps.Marker({
    //     position: myLatlng,
    //     map: map,
    //     icon: image
    // });
    //
    // if (infoBox === true) {
    //     google.maps.event.addListener(marker, 'click', function () {
    //         infowindow.open(map, marker);
    //     });
    // }

    $('#js-map-canvas').children('div').css('background-color', '#f2f2f2');
}


$('document').ready(function () {
    // Width
    var width = window.innerWidth || document.body.clientWidth;

    // Detect language
    var userLang = navigator.language;
    $('html').attr('lang', userLang);

    // Debug mode
    if ($('pre').length > 0) {
        $('pre').each(function (e) {
            $('#debugModal .modal-body').append($(this));
        });
        $('#debugModal').modal('show');
        document.addEventListener('keyup', doc_keyUp, false);
    }

    // Fade in / fade out page transition
    if ($('.js-site--fade').length > 0) {
        siteFade();
    }

    if ($('.js-link').length > 0) {
        jsLink();
    }

    // Check touch devices
    var checkMobile = function () {
        var isTouch = ('ontouchstart' in document.documentElement);
        if (isTouch) {
            $('html').addClass('touch');
        } else {
            $('html').addClass('no-touch');
        }
    };
    checkMobile();

    // Slider
    if ($('.js-slider-images').length > 0) {
        $('.js-slider-images').each(function () {
            var $this = $(this);

            var sliderId = $(this).data('slider');
            var nextEl = '.js-slider-button-next-' + sliderId;
            var prevEl = '.js-slider-button-prev-' + sliderId;
            var progressBar = '.js-slider-pagination-' + sliderId;

            var sliderImages = new Swiper($this, {
                //loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 400,
                pagination: {
                    el: progressBar,
                    type: 'progressbar',
                },
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl
                }
            });

            sliderImages.on('slideChange', function () {
                $this.parents('.js-images-wrapper').find('.slider-bar_count .js-count').html(sliderImages.activeIndex + 1);
                $this.parents('.js-images-wrapper').find('.js-overlay-text, .animation-fade_top, .animation-scale_x, .animation-fade_bottom').removeClass('animation-active');

                if (sliderImages.activeIndex + 1 > 1) {
                    $this.parents('.js-images-wrapper').find('.js-overlay-text, .animation-fade_top, .animation-scale_x, .animation-fade_bottom').addClass('animation-active');
                }
            });
        });
    }

    // Lightgallery slider
    if ($('.js-lightgallery-slider').length > 0) {
        $('.js-lightgallery-slider').lightGallery({
            counter: false,
            download: false,
            mode: 'lg-fade',
            cssEasing: 'cubic-bezier(.45, .06, .15, 1)',
            selector: '.js-gallery',
        });
    }

    // Google maps
    if ($('#js-map-canvas').length > 0) {
        initializeMap('js-map-canvas', true, true);
    }

    // Cookies
    $.fn.queueAddClass = function(className) {
        this.queue('fx', function(next) {
            $(this).addClass(className);
            next();
        });
        return this;
    };

    if ($.cookie('cookies-valid')) {
        $('.bs-cookies').addClass('bs-cookies-hide hidden').removeClass('bs-cookies-show');
    } else {
        $('.bs-cookies').addClass('bs-cookies-show').removeClass('bs-cookies-hide hidden');
    }

    $('#bs-cookies-dismiss').click(function (e) {
        e.preventDefault();
        $.cookie('cookies-valid', true, {expires: 3650, path: '/'});
        $('.bs-cookies').addClass('bs-cookies-hide').removeClass('bs-cookies-show').delay(300).queueAddClass('hidden');
    });

    // Headroom
    if ($('.header-main').length > 0 && width > 1200) {
        var navbar = document.querySelector('.header-main');
        var offsetElement = 150;

        new Headroom(navbar, {
            'offset' : offsetElement,
            'classes': {
                initial : "headroom",
                // when scrolling up
                pinned : "headroom--pinned",
                // when scrolling down
                unpinned : "headroom--unpinned",
                // when above offset
                top : "headroom--top",
                // when below offset
                notTop : "headroom--not-top"
            }
        }).init();
    }

    // Margin to boxes
    // if ($('.js-add-m').length > 0 && width > 991) {
    //     $('.js-outer-h').height();
    //
    //     var outerH = $('.js-outer-h').height();
    //     var innerH = $('.js-inner-h').height();
    //
    //     var marginH = outerH - innerH;
    //
    //     $('.js-add-m').attr('style', 'margin-top: ' + marginH + 'px !important');
    // }

    $(window).scroll(function(){
        if ($(window).scrollTop() >= 56 && width > 991) {
            $('.header-main').addClass('header-main-fixed');
        }
        else {
            $('.header-main').removeClass('header-main-fixed');
        }
    });
});